import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import GlobalErrorBoundary from "@/components/GlobalErrorBoundary";

// HOTFIX: Import build version for cache tracking
import './buildVersion';

const root = ReactDOM.createRoot(document.getElementById("root"));
// Note: StrictMode disabled for compatibility with drag-and-drop library
root.render(
  <GlobalErrorBoundary>
    <App />
  </GlobalErrorBoundary>
);
